import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import type { Building } from '@/typings/buildings/Building';
import type { Project } from '@/typings/projects/Project';
import type { Region } from '@/typings/regions/Region';
import type { Unit } from '@/typings/units/Unit';

export function usePurchaseLocalizedUrls() {
  const { locale } = useI18n();

  const buyUrl = computed(() => {
    return locale.value === 'fr-CA' ? '/achat' : '/en/purchase';
  });

  function getBuildingWizardUrl(building: Building) {
    return `${buyUrl.value}/${building.localizedRegionSlug}/${building.localizedProjectSlug}/${building.localizedSlug}`;
  }

  function getBuildingWizardUrlFromUnit(unit: Unit) {
    return `${buyUrl.value}/${unit.localizedRegionSlug}/${unit.localizedProjectSlug}/${unit.localizedBuildingSlug}`;
  }
  
  function getRegionWizardUrl(region: Region) {
    return `${buyUrl.value}/${region.localizedSlug}`;
  }

  function getRegionWizardUrlFromProject(project: Project) {
    return `${buyUrl.value}/${project.localizedRegionSlug}`;
  }

  function getProjectWizardUrl(project: Project) {
    return `${buyUrl.value}/${project.localizedRegionSlug}/${project.localizedSlug}`;
  }

  function getProjectWizardUrlFromBuilding(building: Building) {
    return `${buyUrl.value}/${building.localizedRegionSlug}/${building.localizedProjectSlug}`;
  }

  function getPurchaseUnitWizardUrl(unit: Unit) {
    return `${buyUrl.value}/${unit.localizedRegionSlug}/${unit.localizedProjectSlug}/${unit.localizedBuildingSlug}/${unit.localizedFloorSlug}/${unit.localizedSlug}`;
  }

  return {
    getBuildingWizardUrl,
    getBuildingWizardUrlFromUnit,
    getProjectWizardUrl,
    getProjectWizardUrlFromBuilding,
    getRegionWizardUrl,
    getRegionWizardUrlFromProject,
    getPurchaseUnitWizardUrl,
    purchaseWizardFirstStepUrl: buyUrl.value,
    homeUrl: locale.value === 'fr-CA' ? '/' : '/en',
    buyUrl: buyUrl.value
  };
}
